const Xl = () => {
  return (
    <svg
      version="1.0"
      width="24.000000pt"
      height="24.000000pt"
      viewBox="0 0 150.000000 133.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,133.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M291 1293 c-67 -34 -92 -124 -51 -190 36 -60 90 -78 162 -54 99 33
113 178 23 237 -37 24 -95 27 -134 7z"
        />
        <path
          d="M1093 1294 c-70 -36 -94 -129 -50 -195 28 -42 60 -59 112 -59 98 0
165 104 121 188 -37 70 -118 99 -183 66z"
        />
        <path
          d="M223 1025 c-17 -7 -38 -24 -46 -37 -21 -33 -137 -404 -137 -438 0
-49 18 -74 121 -164 54 -48 99 -93 99 -99 0 -7 -5 -56 -10 -110 -7 -68 -6
-104 1 -121 27 -58 113 -47 123 16 15 97 26 270 17 286 -5 10 -36 41 -67 70
l-58 51 28 93 c15 51 33 106 40 123 l12 29 42 -76 c24 -44 50 -78 61 -81 28
-7 61 20 61 49 l0 24 239 0 238 0 7 -30 c6 -32 36 -51 67 -43 9 3 34 38 55 79
21 40 42 74 45 74 3 0 22 -53 42 -119 l37 -119 -67 -65 -67 -65 12 -142 c13
-164 24 -190 76 -190 61 0 69 21 61 157 l-7 119 100 92 c105 97 130 137 117
190 -3 15 -33 111 -66 214 -65 206 -82 232 -150 243 -41 7 -81 -9 -114 -45
-15 -17 -20 -37 -21 -84 0 -52 -6 -71 -35 -119 l-34 -58 -5 148 -5 148 -282 3
-283 2 0 -150 c0 -101 -3 -149 -10 -145 -21 13 -72 127 -66 149 8 32 -10 96
-33 117 -42 39 -86 47 -138 24z"
        />
      </g>
    </svg>
  );
};

export default Xl;
